"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALIDATE_REGEX = void 0;
exports.VALIDATE_REGEX = {
    VALIDATE_HEX_COLOR: /^#([a-f0-9]{3}){1,2}\b$/i,
    // @TODO: 좀 더 정확한 범위의 regex로 수정
    VALIDATE_RGB_RGBA_COLOR: /^rgb\(\d{1,3}%?(,\s?\d{1,3}%?){2}\)|rgba\((\d{1,3}%?,\s?){3}(1|0?\.\d+)\)$/i
};
